import { observable, computed } from 'mobx';
import { capitalize } from '../../core/utils';

export default class BgCheckReport {
  @observable programMemberId: number = null;
  @observable status: string = null;
  @observable insertedAt: string = null;
  @observable reportId: string = null;
  @observable email: string = null;
  @observable billCandidate: boolean = null;
  @observable engaged: boolean = null;

  @computed
  get statusCapitalized() {
    return capitalize(this.status);
  }

  @computed
  get billed() {
    return this.billCandidate ? this.email : 'Organization';
  }
}
